import Meta from '@/components/common/Meta'

import StorageAndShippingCompaniesPage from '@/v2/components/pages/landing-pages/storage-and-shipping-companies-page'
import { LANDING_PAGES_META_CONTENTS } from '@/v2/constants/pages/landing-pages/meta/landing-pages-meta-content'
import { metaImages, ogImages } from '@/v2/constants/pages/landing-pages/storage-and-shipping-companies-page'

interface StorageAndShippingCompaniesPageProps {}

const Page: React.FC<StorageAndShippingCompaniesPageProps> = () => {
  return (
    <>
      <Meta
        title={
          LANDING_PAGES_META_CONTENTS.storage_and_shipping_companies.title ??
          LANDING_PAGES_META_CONTENTS.default?.title ??
          ''
        }
        keywords={
          LANDING_PAGES_META_CONTENTS.storage_and_shipping_companies?.keywords ??
          LANDING_PAGES_META_CONTENTS.default?.keywords ??
          ''
        }
        description={
          LANDING_PAGES_META_CONTENTS.storage_and_shipping_companies?.description ??
          LANDING_PAGES_META_CONTENTS.default?.description ??
          ''
        }
        openGraph={{
          images: ogImages
        }}
        searchImages={metaImages}
      />

      <StorageAndShippingCompaniesPage />
    </>
  )
}

export default Page
